export default __webpack_public_path__ + "static/media/G0050.34I-26050_-17332_0.1666195680000.1b60c02e.jpg";